module.exports = __webpack_public_path__ + "static/img/fengwangjiang.84d8902a.png";